import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkShareholderDetail({category = {}, children}) {
    const slug = category.title && category.id ? `${changeToSlug(category.title)}-l${category.id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
